<template>
  <div class="info">
    <div class="header">
      <p class="title">发布找货需求</p>
      <p class="close" @click="$emit('cancel')">关闭</p>
    </div>

    <div class="body">
      <van-field
        v-model="form.product_name"
        label="产品名称"
        placeholder="请输入产品名称"
        required
      />

      <van-field
        v-model="form.remark"
        label="备注"
        type="textarea"
        rows="4"
        autosize
        placeholder="请输入您的真实需求"
        required
      />

      <div class="img-card">
        <div class="img-title">
          <span>添加图片（最多9张）</span>
          <span class="count">{{ images.length }}/9</span>
        </div>

        <div class="img-grid">
          <div
            class="img-item"
            v-for="(it, idx) in images"
            :key="idx"
          >
            <van-image
              class="img"
              :src="fullImg(it.url)"
              fit="cover"
              @click="preview(idx)"
            />
            <div class="del" @click="remove(idx)">×</div>
          </div>

          <div
            class="img-add"
            v-if="images.length < 9"
            @click="chooseAndUpload"
          >
            <div class="plus">+</div>
            <div class="text">添加图片</div>
          </div>
        </div>

        <p class="tip">提示：请在微信内打开；图片会先上传到微信，再换取服务器图片地址。</p>
      </div>
    </div>

    <div class="footer">
      <van-button class="btn cancel" @click="$emit('cancel')">取消</van-button>
      <van-button class="btn submit" type="primary" :loading="submitting" @click="submit">提交</van-button>
    </div>
  </div>
</template>

<script>
import CommonService from '@/io/common.js';

export default {
  name: 'HelpFindGoodsInfo',
  data() {
    return {
      form: {
        product_name: '',
        remark: '',
      },
      // 存服务器返回的图片路径（相对路径或完整URL）
      images: [], // [{ url: '/Uploads/xxx.jpg' }]
      uploading: false,
      submitting: false,
    };
  },
  methods: {
    ensureWx() {
      const wx = window.wx;
      if (!wx || !wx.chooseImage || !wx.uploadImage) {
        this.$toast('请在微信内打开，或确认已注入 JSSDK');
        return null;
      }
      return wx;
    },

    // 选择并上传（多张）
    chooseAndUpload() {
      if (this.uploading) return;

      const wx = this.ensureWx();
      if (!wx) return;

      const remain = 9 - this.images.length;
      if (remain <= 0) return;

      wx.chooseImage({
        count: remain,
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          const localIds = res.localIds || [];
          if (!localIds.length) return;
          this.uploadLocalIdsSequential(localIds);
        },
        fail: () => {
          this.$toast('选择图片失败');
        }
      });
    },

    // 逐张上传，避免并发导致 wx.uploadImage 不稳定
    uploadLocalIdsSequential(localIds) {
      const wx = this.ensureWx();
      if (!wx) return;

      this.uploading = true;
      this.$toast.loading({ message: '上传中...', duration: 0 });

      const next = (idx) => {
        if (idx >= localIds.length) {
          this.uploading = false;
          this.$toast.clear();
          return;
        }

        wx.uploadImage({
          localId: localIds[idx],
          isShowProgressTips: 1,
          success: (r) => {
            const mediaId = r.serverId; // 微信返回的 media_id
            // 把 media_id 交给后端换取图片路径
            CommonService.helpFindGoodsUpload(mediaId)
              .then(apiRes => {
                const url = this.pickUploadUrl(apiRes);
                if (url) {
                  this.images.push({ url });
                } else {
                  this.$toast('上传返回异常');
                }
              })
              .catch(() => {
                this.$toast('上传失败');
              })
              .finally(() => {
                next(idx + 1);
              });
          },
          fail: () => {
            this.$toast('微信上传失败');
            next(idx + 1);
          }
        });
      };

      next(0);
    },

// ✅ 兼容不同返回结构：最终拿到 filename/url/path 字符串
pickUploadUrl(res) {
  if (!res) return '';

  // 1) 你项目常见：拦截器后 res = payload
  // payload: { status, msg, data: { filename } }
  if (res.data && typeof res.data.filename === 'string') return res.data.filename;

  // 2) 有时你可能直接传了 data 对象进来：{ filename }
  if (typeof res.filename === 'string') return res.filename;

  // 3) 若没有拦截器：axios 原始 response
  // response: { data: payload }, payload.data.filename
  if (res.data && res.data.data && typeof res.data.data.filename === 'string') return res.data.data.filename;

  // 4) 兼容其它字段
  const d = res.data && typeof res.data === 'object' ? res.data : res;
  if (typeof d === 'string') return d;
  if (d.url) return d.url;
  if (d.path) return d.path;
  if (d.photo) return d.photo;

  return '';
},


fullImg(p) {
  if (!p) return '';
  if (/^https?:\/\//i.test(p)) return p;
  const base = process.env.VUE_APP_IMAGE_URL || '';
  if (!base) return p;
  if (base.endsWith('/') || p.startsWith('/')) return `${base}${p}`;
  return `${base}/${p}`;
},


    preview(idx) {
      const wx = window.wx;
      const urls = this.images.map(it => this.fullImg(it.url));
      const current = urls[idx];
      if (wx && wx.previewImage) {
        wx.previewImage({ current, urls });
      }
    },

    remove(idx) {
      this.images.splice(idx, 1);
    },

    submit() {
      const productName = (this.form.product_name || '').trim();
      const remark = (this.form.remark || '').trim();

      if (!productName) {
        this.$toast('请输入产品名称');
        return;
      }
      if (!remark) {
        this.$toast('请输入备注/真实需求');
        return;
      }
      if (this.uploading) {
        this.$toast('图片上传中，请稍后');
        return;
      }

      const imagesStr = this.images.map(it => it.url).join(',');

      this.submitting = true;
      this.$toast.loading({ message: '提交中...', duration: 0 });

      CommonService.helpFindGoodsAddDemand(productName, remark, imagesStr)
        .then(res => {
          this.$toast.success(res.msg || '提交成功');
          this.reset();
          this.$emit('submit');
        })
        .catch(() => {})
        .finally(() => {
          this.submitting = false;
          this.$toast.clear();
        });
    },

    reset() {
      this.form.product_name = '';
      this.form.remark = '';
      this.images = [];
      this.uploading = false;
      this.submitting = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../assets/styles/tools.less';

.info {
  height: 100%;
  background: #F6F7F9;
  display: flex;
  flex-direction: column;

  .header {
    background: #fff;
    padding: 28 * @r 32 * @r;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title { font-size: 32 * @r; font-weight: bold; }
    .close { font-size: 26 * @r; color: @color-primary; }
  }

  .body {
    flex: 1;
    overflow-y: auto;
    padding: 22 * @r 26 * @r;

    /deep/ .van-field {
      border-radius: 16 * @r;
      margin-bottom: 18 * @r;
      background: #fff;
    }

    .img-card {
      background: #fff;
      border-radius: 16 * @r;
      padding: 22 * @r;

      .img-title {
        display: flex;
        justify-content: space-between;
        font-size: 26 * @r;
        margin-bottom: 16 * @r;
        .count { color: #82858B; }
      }

      .img-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 14 * @r;
      }

      .img-item {
        position: relative;
        width: 200 * @r;
        height: 200 * @r;

        /deep/ .img {
          width: 200 * @r;
          height: 200 * @r;
          border-radius: 12 * @r;
          overflow: hidden;
        }

        .del {
          position: absolute;
          right: -10 * @r;
          top: -10 * @r;
          width: 44 * @r;
          height: 44 * @r;
          border-radius: 22 * @r;
          background: rgba(0,0,0,.6);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30 * @r;
        }
      }

      .img-add {
        width: 200 * @r;
        height: 200 * @r;
        border-radius: 12 * @r;
        border: 2px dashed #D8D8D8;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #82858B;

        .plus { font-size: 46 * @r; line-height: 46 * @r; }
        .text { margin-top: 10 * @r; font-size: 22 * @r; }
      }

      .tip {
        margin-top: 16 * @r;
        font-size: 22 * @r;
        color: #82858B;
      }
    }
  }

  .footer {
    background: #fff;
    padding: 18 * @r 26 * @r;
    display: flex;
    gap: 18 * @r;

    .btn {
      flex: 1;
      height: 88 * @r;
      border-radius: 44 * @r;
      font-size: 28 * @r;
    }
    .cancel {
      background: #F2F3F5;
      border: none;
    }
  }
}
</style>
